import { useEffect, useState } from 'react'

/**
 * Wie viel des Fensters die Bildschirmtastatur gerade verdeckt, in Pixeln.
 *
 * Ein Element mit `position: fixed; bottom: 0` sitzt am unteren Rand des **Layout**-
 * Viewports. Die Tastatur verkleinert aber nur den **visuellen** Viewport — das Feld
 * bleibt also dort, wo es war, und liegt anschließend hinter der Tastatur. Auf iOS ist
 * das verlässlich zu beobachten, auf Android je nach Einstellung des Browsers.
 *
 * Die Differenz beider Viewports ist die gesuchte Höhe. `offsetTop` gehört in die
 * Rechnung, weil iOS den visuellen Viewport zusätzlich verschiebt, sobald man bei
 * offener Tastatur scrollt.
 *
 * Ohne `visualViewport` (ältere Browser) bleibt das Ergebnis 0. Die Ansicht sitzt dann
 * wie bisher am unteren Rand — nicht schön bei offener Tastatur, aber nicht kaputt.
 */
export function useTastaturhoehe(): number {
  const [hoehe, setHoehe] = useState(0)

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return

    const messen = () => {
      const verdeckt = window.innerHeight - viewport.height - viewport.offsetTop
      // Aufrunden statt runden: Ein halber Pixel zu wenig lässt eine Kante der Tastatur
      // stehen, ein halber zu viel fällt niemandem auf.
      setHoehe(Math.max(0, Math.ceil(verdeckt)))
    }

    messen()
    viewport.addEventListener('resize', messen)
    viewport.addEventListener('scroll', messen)
    return () => {
      viewport.removeEventListener('resize', messen)
      viewport.removeEventListener('scroll', messen)
    }
  }, [])

  return hoehe
}
